(ns teamoesterreich.admin-mode.modal.are-you-sure-modal
  (:require [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.util.log :as log]))


(defn are-you-sure-modal [!show message ok-message on-ok-fn & [on-cancel-fn]]

  [mui/modal
   {
    :aria-labelledby  "simple-modal-title"
    :aria-describedby "simple-modal-description"
    :style            {:display        "flex"
                       :marginRight    "auto"
                       :marginLeft     "auto"
                       :alignItems     "center"
                       :justifyContent "center"}
    :open             (if @!show true false)

    }
   [:div
    {
     :class "modal"
     :style {:width 600}}
    [:h4 message]

    [:br]
    [:br]
    [mui/button
     {:color     "primary"
      :variant   "contained"
      :startIcon (r/as-element [keyboard-arrow-left])
      :style     {:marginRight 50}
      :onClick   (fn []
                   (if on-cancel-fn
                     (on-cancel-fn)
                     (reset! !show false)))
      }
     "Abbrechen"]
    [mui/button
     {:style     {:float "right"}
      :variant   "contained"
      :startIcon (r/as-element [done])
      :onClick   (fn []
                   (on-ok-fn)
                   (reset! !show false))
      }
     ok-message]]
   ]
  )


(defn are-you-sure-confirm-modal [!show message confirm ok-message on-ok-fn & [on-cancel-fn]]
  (let [!confirm (r/atom "")]
    (fn []
      [mui/modal
       {
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (if @!show true false)

        }
       [:div
        {
         :class "modal"
         :style {:width 600}}
        [:h4 message]
        [mui/text-field
         {:onChange  (fn [e] (reset! !confirm (h/event-value e)))
          :fullWidth true
          }]
        [:br]
        [:br]
        [mui/button
         {:color     "primary"
          :variant   "contained"
          :startIcon (r/as-element [keyboard-arrow-left])
          :style     {:marginRight 50}
          :onClick   (fn []
                       (if on-cancel-fn
                         (on-cancel-fn)
                         (reset! !show false)))
          }
         "Abbrechen"]
        [mui/button
         {:style     {:float "right"}
          :variant   "contained"
          :disabled  (if (= confirm @!confirm) false true)
          :startIcon (r/as-element [done])
          :onClick   (fn []
                       (on-ok-fn)
                       (reset! !show false))
          }
         ok-message]]
       ]
      )))


